export { InputPassword } from './component';
